import { SlateToHtmlConfig } from "@slate-serializers/html";
import { ChildNode, Element } from 'domhandler'

type MarkTransform = ({ node, attribs }: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node?: any;
  attribs?: { [key: string]: string }
}) => Element | undefined
interface MarkTransforms {
  [key: string]: MarkTransform
}

export type ElementTransform = ({
  node,
  attribs,
  children,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node?: any
  attribs?: { [key: string]: string }
  children?: ChildNode[]
}) => Element | undefined
type AttributeTransform = ({
  node,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node: any
}) => { [key: string]: string } | undefined

interface ElementTransforms {
  [key: string]: ElementTransform
}
interface BaseConfig {
  markMap: { [key: string]: string[] }
  elementMap: { [key: string]: string }
  // markAttributeTransform?: AttributeTransform
  elementAttributeTransform?: AttributeTransform
  defaultTag?: string
  encodeEntities?: boolean
  alwaysEncodeBreakingEntities?: boolean
  alwaysEncodeCodeEntities?: boolean
  convertLineBreakToBr?: boolean
}
interface Config extends BaseConfig {
  markTransforms?: MarkTransforms
  elementTransforms: ElementTransforms
}

const ELEMENT_NAME_TAG_MAP = {
  p: 'p',
  paragraph: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  ul: 'ul',
  ol: 'ol',
  li: 'li',
  blockquote: 'blockquote',
}

const MARK_ELEMENT_TAG_MAP = {
  strikethrough: ['s'],
  bold: ['strong'],
  underline: ['u'],
  italic: ['i'],
  code: ['pre', 'code'],
}

const styleToString = (style: { [key: string]: string }) => {
  return Object.keys(style).reduce(
    (acc, key) =>
      acc +
      key
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase() +
      ':' +
      style[key] +
      ';',
    '',
  )
}
const config: Config = {
  markMap: MARK_ELEMENT_TAG_MAP,
  elementMap: ELEMENT_NAME_TAG_MAP,
  elementAttributeTransform: ({ node }) => {
    if (node.align) {
      return {
        style: styleToString({
          ['text-align']: node.align,
        })
      }
    }
    return
  },
  elementTransforms: {
    quote: ({ children = [] }) => {
      const p = [new Element('p', {}, children)]
      return new Element('blockquote', {}, p)
    },
    link: ({ node, children = [] }) => {
      const attrs: any = {}
      if (node.newTab) {
        attrs.target = '_blank'
      }
      return new Element(
        'a',
        {
          href: node.url,
          ...attrs,
        },
        children,
      )
    },
  },
  encodeEntities: false,
  alwaysEncodeBreakingEntities: true,
  alwaysEncodeCodeEntities: false,
  convertLineBreakToBr: false,
}
// {type: 'image', url: 'https://www.portplay.org/resources/event-edit/978-1-76358-980-3.png', children: Array(1)}

export const serializerConfig: SlateToHtmlConfig = {
  ...config,
  elementTransforms: {
    ...config.elementTransforms,
    
    image: ({ node, children = [] }) => {
      //const attrs: any = {}
      return new Element(
        'img',
        {
          src: node.url,
//          ...attrs,
        },
      )
    },
    'list-item': ({ node, children = [] }) => {
      return new Element(
        'li', {}, children,
      )
    },
    'bulleted-list': ({ node, children = [] }) => {
      return new Element(
        'ul', {}, children,
      )
    },
    'numbered-list': ({ node, children = [] }) => {
      return new Element(
        'ol', {}, children,
      )
    }

  },
}
